import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-black/80 backdrop-blur-sm text-white pt-10 pb-4">
      <div className="container mx-auto px-6">
        {/* Main footer grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8 text-sm">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <img
              src="https://res.cloudinary.com/daka2lob2/image/upload/v1751272742/Touks_logo3_ed9w6g.png"
              alt="Tõuks.ee"
              className="h-10 mb-3"
            />
            <p className="text-gray-400 leading-relaxed text-xs">
              Eesti trikitõukside spetsialist. Blunt, Aztek, Drone ja teised tippmargid.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="https://www.facebook.com/profile.php?id=61575512052915"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Tõuks.ee Facebook"
                className="text-gray-400 hover:text-[#4FC1E9] transition-colors duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/touks.ee/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Tõuks.ee Instagram"
                className="text-gray-400 hover:text-[#4FC1E9] transition-colors duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <p className="font-semibold text-white mb-3">Pood</p>
            <div className="flex flex-col gap-2">
              {[
                { to: '/toukeratas', label: 'Tõukerattad' },
                { to: '/toukeratas/tald', label: 'Tallad' },
                { to: '/toukeratas/lenks', label: 'Lenksud' },
                { to: '/toukeratas/brandid', label: 'Brändid' },
              ].map(({ to, label }) => (
                <Link key={to} to={to} className="text-gray-400 hover:text-[#4FC1E9] transition-colors duration-300">
                  {label}
                </Link>
              ))}
            </div>
          </div>

          {/* Info */}
          <div>
            <p className="font-semibold text-white mb-3">Info</p>
            <div className="flex flex-col gap-2">
              {[
                { to: '/blogi', label: 'Blogi' },
                { to: '/meist', label: 'Meist' },
                { to: '/kontakt', label: 'Kontakt' },
                { to: '/kohaletoimetamine', label: 'Kohaletoimetamine' },
                { to: '/garantii-ja-tagastamine', label: 'Tagastamine' },
              ].map(({ to, label }) => (
                <Link key={to} to={to} className="text-gray-400 hover:text-[#4FC1E9] transition-colors duration-300">
                  {label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="font-semibold text-white mb-3">Kontakt</p>
            <div className="flex flex-col gap-2">
              <Link to="/kontakt" className="text-gray-400 hover:text-[#4FC1E9] transition-colors duration-300">
                Kirjuta meile
              </Link>
              <a
                href="mailto:ametliktouks@gmail.com"
                className="text-gray-400 hover:text-[#4FC1E9] transition-colors duration-300"
              >
                ametliktouks@gmail.com
              </a>
              <p className="text-gray-500 text-xs mt-1">Vastame 1 tööpäeva jooksul</p>
              <img
                src="https://res.cloudinary.com/daka2lob2/image/upload/v1774458462/Pangalinkid_rkf3gc_uubbo9.webp"
                alt="Pangalingid ja makseviisid"
                className="mt-2 w-full max-w-[250px]"
              />
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-4 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-2 text-sm md:text-base">
          <div className="flex justify-center md:justify-start items-center">© {new Date().getFullYear()} Tõuks.ee</div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-2">
            <Link to="/muugitingimused" className="text-white hover:text-[#4FC1E9] transition-colors duration-300">
              Müügitingimused
            </Link>
            <span className="hidden md:inline-block text-gray-400">|</span>
            <Link to="/privaatsustingimused" className="text-white hover:text-[#4FC1E9] transition-colors duration-300">
              Privaatsuspoliitika
            </Link>
          </div>
          <div className="flex justify-center md:justify-end items-center">
            <a
              href="https://kvantis.ee/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#4FC1E9] hover:text-white transition-colors duration-300"
            >
              Veebilehe looja Kvantis
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
